<template>
  <div v-show="this.user.type !== '5'">
    <van-tabbar
      v-model="active"
      style="height: 100px"
      :placeholder="true"
      route
      safe-area-inset-bottom
      active-color="#f29c4c"
      inactive-color="#a8a29d"
    >
      <van-tabbar-item to="/dashboard">
        <template #icon="props">
          <img
            :class="[this.user.auth_list && this.user.auth_list.includes('call') ? 'footer-img-size' : 'footer-img-size_false']"
            :src="
              props.active
                ? require('../assets/img/common/btn_home_current.png')
                : require('../assets/img/common/btn_home.png')
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/PatientList" v-show="this.user.auth_list && this.user.auth_list.includes('call')">
        <template #icon="props">
          <img
            class="footer-img-size"
            :src="
              props.active
                ? require('../assets/img/common/btn_user_current.png')
                : require('../assets/img/common/btn_user.png')
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/teamList">
        <template #icon="props">
          <img
            :class="[this.user.auth_list && this.user.auth_list.includes('call') ? 'footer-img-size' : 'footer-img-size_false']"
            :src="
              props.active
                ? require('../assets/img/common/btn_tel_current.png')
                : require('../assets/img/common/btn_tel.png')
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/user">
        <template #icon="props">
          <img
            :class="[this.user.auth_list && this.user.auth_list.includes('call') ? 'footer-img-size' : 'footer-img-size_false']"
            :src="
              props.active
                ? require('../assets/img/common/btn_mypage_current.png')
                : require('../assets/img/common/btn_mypage.png')
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String,
  },
  data() {
    return {
      active: 0,
      user:{
        auth_list:[]
      },
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
  },
  methods: {},
};
</script>

<style scoped>
.footer-img-size {
  width: 88%;
  height: auto !important;
  vertical-align: bottom;
  margin: 0 auto;
}
.footer-img-size_false {
    width: 66%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
}
@media screen and (min-width: 500px) {
  .footer-img-size {
    width: 66%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
  .footer-img-size_false {
    width: 50%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
}
@media screen and (min-width: 600px) {
  .footer-img-size {
    width: 55%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
  .footer-img-size_false {
    width: 40%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
}
@media screen and (min-width: 700px) {
  .footer-img-size {
    width: 43%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
  .footer-img-size_false {
    width: 35%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
}
@media screen and (min-width: 1023px) {
  .footer-img-size {
    width: 50%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
  .footer-img-size_false {
    width: 50%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
}
@media screen and (min-width: 1150px) {
  .footer-img-size {
    width: 50%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
  
}
@media screen and (min-width: 1300px) {
  .footer-img-size {
    width: 50%;
    height: auto !important;
    vertical-align: bottom;
    margin: 0 auto;
  }
  
}
</style>